import pl from 'element-ui/lib/locale/lang/pl';

// 波兰语(波兰)
export default {
  ...pl,
  layout: {
    title: 'Logowanie przy użyciu identyfikatora Uniportal',
    tip: 'Niezarejestrowany numer telefonu komórkowego zostanie automatycznie zarejestrowany po pomyślnym zalogowaniu',
    line: 'Inne opcje logowania',
  },
  button: {
    submit: 'Logowanie / Rejestracja',
    getCode: 'Uzyskaj kod',
    emailRegister: 'Rejestracja z użyciem poczty e-mail',
    w3Login: 'Logowanie do konta W3',
    employeeLogin: 'logowanie pracownika',
    passwordLogin: 'Login hasłem',
    reSend: 'Wyślij ponownie',
    problem: 'Pomoc online',
    privacyPolicy: 'Oświadczenie o ochronie prywatności',
  },
  placeholder: {
    phoneNumber: 'Numer telefonu komórkowego',
    verificationCode: 'Kod weryfikacyjny z wiadomości SMS',
  },
  dialog: {
    imgCode: 'Wprowadź znaki widoczne na ilustracji.',
    userAgreements: {
      header: 'Umowa z użytkownikiem i Zasady zachowania poufności informacji',
      text1: 'Zapoznaj się z dokumentami {privacy} oraz {agreement} i wyraź na nie zgodę.',
      text2:
        'Podczas uzyskiwania dostępu do aplikacji Huawei poza Chinami, dane osobowe będą przekazywane do podmiotów zależnych Huawei za granicą w celu ich przetwarzania. Szczegółowe informacje można znaleźć na stronie {privacy}',
    },
    crossBorder: {
      header: 'Wskazówki dotyczące autoryzacji',
      text: 'Usługa lokalna, z której korzystasz, nie znajduje się w tym samym regionie, w którym zarejestrowano Twoje konto.Transgraniczny dostęp do informacji o koncie wymaga Twojej zgody.',
    },
    multiAccounts: 'Wybierz konto.',
    agreeButton: 'Zgadzam się, kontynuuj',
    disagreeButton: 'Nie zgadzam się',
    confirmButton: 'Potwierdź',
    cancelButton: 'Anuluj',
    knowMe: 'Potwierdzam',
  },
  toast: {
    hasSend: 'Wysłano kod weryfikacyjny.',
    wait: 'Proszę zaczekać',
  },
  tooltip: {
    Huawei: 'ID Huawei',
    Tencent: 'QQ',
    Wechat: 'Wechat',
    Weibo: 'Weibo',
    Google: 'Google',
    Facebook: 'Facebook',
    Linkedin: 'LinkedIn',
  },
  errorCode: {
    // 图形验证码错误
    'IDC-00-00013': 'Kod CAPTCHA nie może być pusty.',
    'IDC-03-0002': 'Kod CAPTCHA wygasł.',
    'IDC-00-0004': 'Nieprawidłowy kod CAPTCHA.',

    // 表单输入为空
    'IDC-01-00024': 'Kod kraju jest wymagany do weryfikacji numeru telefonu komórkowego.',
    phoneNumberEmpty: 'Wprowadź numer telefonu komórkowego.',
    'IDC-03-00033': 'Wprowadź kod weryfikacyjny z wiadomości SMS.',

    // 表单数据错误
    'IDC-02-00227': 'Wprowadzony numer telefonu komórkowego nie pasuje do wybranego kraju/regionu',
    'IDC-02-00226': 'Kod kraju jest zablokowany',
    'IDC-02-00029': 'Kod weryfikacyjny jest nieprawidłowy lub wygasł',
    'IDC-02-0013': 'Logowanie SMS nie powiodło się, kod weryfikacyjny jest nieprawidłowy',
    'IDC-02-0020': 'Weryfikacja nie powiodła się. Nieprawidłowy kod weryfikacyjny.',
    'IDC-02-00028': 'Numer telefonu komórkowego musi składać się z cyfr o długości od 6 do 30.',
    'IDC-02-00012': 'Nieprawidłowy numer telefonu komórkowego',

    // 错误操作锁定
    accountLock:
      'Nieprawidłowy numer telefonu komórkowego lub kod weryfikacyjny. Pozostała liczba prób: {number}. | Nieprawidłowy numer telefonu komórkowego lub kod weryfikacyjny. Pozostały {number} próby. | Nieprawidłowy numer telefonu komórkowego lub kod weryfikacyjny. Pozostało {number} prób. | Nieprawidłowy numer telefonu komórkowego lub kod weryfikacyjny. Pozostało {number} próby.',
    accountLocked:
      'Zbyt wiele nieudanych prób. Spróbuj ponownie za {number} s. | Zbyt wiele nieudanych prób. Spróbuj ponownie za {number} sekundy. | Zbyt wiele nieudanych prób. Spróbuj ponownie za {number} sekund. | Zbyt wiele nieudanych prób. Spróbuj ponownie za {number} sekundy.',
    operationRisk: 'Bieżąca operacja jest zagrożona. Spróbuj ponownie za {number} sekund.',

    // 频繁操作
    'IDC-02-00038': 'Spróbuj jeszcze raz za 60 sek.',
    'IDC-02-00064':
      'Zbyt często wysyłasz SMS z kodem weryfikacyjnym. Spróbuj ponownie za 24 godziny.',
    'IDC-02-00211': 'Bieżąca operacja jest zagrożona. Spróbuj ponownie później.',
    'IDC-02-00212':
      'Twój numer telefonu komórkowego wysyła kod weryfikacyjny SMS zbyt często. Spróbuj zmienić numer telefonu lub spróbuj ponownie za 24 godziny!',
    'IDC-02-00213':
      'Zbyt często wysyłasz SMS z kodem weryfikacyjnym. Spróbuj ponownie za 24 godziny.',
    'IDC-02-00215':
      'Twój numer telefonu komórkowego wysyła kod weryfikacyjny SMS zbyt często. Spróbuj zmienić numer telefonu, wybierz inną metodę weryfikacji lub spróbuj ponownie za 24 godziny!',
    'IDC-02-00228': 'Zbyt często wysyłasz SMS z kodem weryfikacyjnym. Spróbuj ponownie za godzinę.',
    'IDC-02-00092': 'Obecna operacja jest zbyt częsta. Spróbuj ponownie 24 godziny później.',

    // 请求异常
    'IDC-10-00400': 'Żądanie klienta jest nieprawidłowe',
    'IDC-10-00500': 'Wewnętrzny błąd systemu ',
    'IDC-02-00264': 'Nieautoryzowane żądania dostępu są zabronione',
    'IDC-02-00063': 'Parametr jest nieprawidłowy',
    'IDC-03-0007': 'Bieżąca operacja jest zagrożona, a rejestracja jest tymczasowo niedostępna.', // 机翻
    'IDC-03-00057': 'Obecna operacja wiąże się z ryzykiem bezpieczeństwa.',

    // 页面过期
    'IDC-00-00017': 'Ta strona wygasła.',
  },

  // 注册协议、隐私声明对话框
  backButton: 'Wstecz',
  closeButton: 'Zamknij',

  // 滑块验证相关：
  resourceReqFailed: 'Żądanie zasobu nie powiodło się. Odśwież stronę i spróbuj ponownie.',
  verifyFailedAndPlsRetry: 'Uwierzytelnianie nie powiodło się. Spróbuj ponownie',
  serviceErrAndPlsRetry: 'Wyjątek usługi. Spróbuj ponownie.',
  learnMore: 'Dowiedz się więcej',
  cookieBannerText:
    'Ta strona internetowa wykorzystuje pliki cookie, aby zapewnić Państwu jak najlepsze wrażenia użytkownika.',
};
